import React from 'react';

interface IconExpandProps {
    width?: number;
    height?: number;
    color?: string;
}

const IconExpand: React.FC<IconExpandProps> = ({ width = 20, height = 20, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M8.1875 5.85156C8.1875 5.3125 8.625 4.875 9.16406 4.875H14.1484C14.6875 4.875 15.125 5.3125 15.125 5.85156V10.8359C15.125 11.375 14.6875 11.8125 14.1484 11.8125C13.6094 11.8125 13.1719 11.375 13.1719 10.8359V6.82812H9.16406C8.625 6.82812 8.1875 6.39062 8.1875 5.85156ZM10.8359 13.1641H6.83203V9.16016C6.83203 8.62109 6.39453 8.18359 5.85547 8.18359C5.31641 8.18359 4.87891 8.62109 4.87891 9.16016V14.1445C4.87891 14.6836 5.31641 15.1211 5.85547 15.1211H10.8398C11.3789 15.1211 11.8164 14.6836 11.8164 14.1445C11.8125 13.6016 11.375 13.1641 10.8359 13.1641Z"
                fill={color}
                fillOpacity="0.5"
            />
        </svg>
    );
};

export default IconExpand;
